import styled, { keyframes } from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { jsx, jsxs } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Container = styled.div.attrs({
  className: 'gz-spinner'
}).withConfig({
  componentId: "gz-spinner-1679042011568__sc-1nqxhx4-0"
})(["display:inline-block;height:24px;position:relative;vertical-align:text-bottom;width:24px;"]);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var spinnerAnimation = keyframes(["100%{transform:rotate(360deg);}"]);
var SvgContainer = styled.svg.attrs({
  className: 'gz-spinner__wrapper',
  viewBox: '25 25 50 50'
}).withConfig({
  componentId: "gz-spinner-1679042011568__sc-1k72udy-0"
})(["animation:2s ", " linear infinite;bottom:0;height:100%;left:0;margin:auto;position:absolute;right:0;top:0;width:100%;will-change:transform;"], spinnerAnimation);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Background = styled.circle.attrs({
  className: 'gz-spinner__background',
  cx: '50',
  cy: '50',
  r: '20'
}).withConfig({
  componentId: "gz-spinner-1679042011568__sc-nd7cgd-0"
})(["fill:transparent;stroke:#ccc;stroke-dasharray:0;stroke-dashoffset:600;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4;"]);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var circleAnimation = keyframes(["0%{stroke-dasharray:0,200;stroke-dashoffset:0;}50%{stroke-dasharray:125,200;stroke-dashoffset:0;}100%{stroke-dasharray:125,200;stroke-dashoffset:-125;}"]);
var Circle = styled.circle.attrs({
  className: 'gz-spinner__circle',
  cx: '50',
  cy: '50',
  r: '20'
}).withConfig({
  componentId: "gz-spinner-1679042011568__sc-jmhflb-0"
})(["animation:1.5s ", " ease-in-out infinite;fill:transparent;stroke:#333;stroke-dasharray:300;stroke-dashoffset:600;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4;will-change:transform;"], circleAnimation);

var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Spinner$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes(rest);
  return /*#__PURE__*/jsx(Container, _objectSpread(_objectSpread({
    className: className,
    role: "status",
    ref: ref // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: /*#__PURE__*/jsxs(SvgContainer, {
      children: [/*#__PURE__*/jsx(Background, {}), /*#__PURE__*/jsx(Circle, {})]
    })
  }));
});
Spinner$1.COMPONENT_ID = 'Gearz.Spinner';
Spinner$1.displayName = Spinner$1.COMPONENT_ID;
Spinner$1.Container = Container;
Spinner$1.SvgContainer = SvgContainer;
Spinner$1.Background = Background;
Spinner$1.Circle = Circle;
Spinner$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.')
};
Spinner$1.defaultProps = {
  className: ''
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Spinner = styled(Spinner$1).withConfig({
  componentId: "gz-spinner-1679042011568__sc-17ealzc-0"
})(["", ""], function (props) {
  return getThemeByProps({
    componentId: Spinner$1.COMPONENT_ID,
    props: props
  });
});
Spinner.displayName = Spinner$1.displayName;
Spinner.propTypes = Spinner$1.propTypes;
Spinner.defaultProps = Spinner$1.defaultProps;

export { Background as B, Container as C, Spinner as S, SvgContainer as a, Circle as b };
